import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelVoidShippingQuote} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class VoidShippingQuoteFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.voidShippingQuote(updatedValues)
      .then((response) => {
        if (response.data.voidShippingQuote.errors.length <= 0) {
          this.props.cancelVoidShippingQuote();
        } else {
          let errors = createValidationErrors(response.data.voidShippingQuote.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelVoidShippingQuote();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to void this quote? All shipping labels for this shipment will be voided."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_PACKAGE = gql`
  mutation voidShippingQuote($data: ShippingIdInput!) {
    voidShippingQuote(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_PACKAGE, {
    props: ({ mutate }) => ({
      voidShippingQuote: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelVoidShippingQuote})(withMutation(VoidShippingQuoteFormContainer));